<template>
  <div class="container">
  
    <el-row style="margin-bottom:20px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/director-work' }">工作台</el-breadcrumb-item>
        <el-breadcrumb-item >发布需求</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <div class="pub_main">
      <h3>发布职位</h3>

      <div class="step_box">
        <div class="step_top">
          <el-steps :active="stepActive" align-center process-status="wait" finish-status="success">
            <el-step v-for="(item,index) in titleList" :title="item.title" :key="index"></el-step>
          </el-steps>
        </div>

        <StepOne v-show="stepActive==1" @handleNextStep="handleNextStep" :info="formData" ref="one"></StepOne>
        <StepTwo v-show="stepActive==2" @handleNextStep="handleNextStep" @handleLastStep="handleLastStep()" :info="formData" ref="two"></StepTwo>
        <StepThree v-show="stepActive==3" @handleLastStep="handleLastStep()"></StepThree>

      </div>
    </div>
  </div>
</template>

<script>
import StepOne from './publish/step-one.vue'
import StepTwo from './publish/step-two.vue'
import StepThree from './publish/step-three.vue'
import { formateDate } from '@/utils/date'
import { jobList,addJob,updateJob,changeStatus,jobDetail} from "@/api/director/job/index.js";

export default {
  components: {
    StepOne, StepTwo, StepThree
  },
  data () {
    return {
      titleList:
      [
        {
            title:'职位信息',
        },{
            title:'薪资信息',
        },{
            title:'等待审核',
        },
          ],
      stepActive: 1,
      job_id:"",
      formData:  {


          project_id:'',//项目id
          company_app_id:'',//企业id
          company_name: '',
          log_img: '',
          title:'',//招聘标题
          logo:'',//招聘头像
          type_id:1,//招聘类型1兼职2全职
          type_remarks:'',//招聘描述
          class_id:'',//职位分类id
          address:[],//地址信息
          job_start_at:'',//活动开始时间-时间戳
          job_end_at:'',//活动结束时间-时间戳
          registration_end_at:'',//报名截止时间
          sex:1,//性别1男2女
          education:1,//学历 0 不限 1 初中及以下 2 高中 3 大专 4 本科 5 研究生
          major:'',//专业要求
          job_require:"",//任职要求
          age_min:0,//最小年龄
          age_max:0,//最大年龄
          photo:[],//工作环境
          description:'',//职位描述

          unit:'1',//工资单位1 天 2 小时 3 月 4 次 5 单
          wages_min:'',//最低薪资
          wages_max:'',//最高薪资
          wages_way:[],//工资计算方式

          method:1,//1:日结，2:月结，3:周结，:4完工结
          benefits:[],//工作福利标签

          work_start_time:'',//每日工作开始时间

          work_end_time:'',//每日工作结束时间

          contact:'',//联系人

          phone:'',//联系电话

      }
    };
  },
  created(){

    if(this.$route.query&&this.$route.query.job_id){
      this.job_id=this.$route.query.job_id;
      this.initJobInfo();

    }
  },
  methods: {
   // 组件点击上一步
   handleLastStep() {
        this.stepActive--
      },
    // 组件点击下一步
    handleNextStep(data) {
      if(this.stepActive==1){
       Object.assign(this.formData, data);
       console.log("this.formData",this.formData);
        this.stepActive++
      }else{
        Object.assign(this.formData, data);
        //提交
        if(this.job_id!=""){
          this.updateJob();
        }else{
         
          this.submitDemand();

        }
      }
      
    },

    initJobInfo(){
      var that=this;
      jobDetail({job_id:this.job_id}).then((response) => {
        console.log('info',response);
        if(response.code==200){
          var info=response.data;

          var obj=  {
              job_id:info.job_id,
              project_id:info.project_id,//项目id
              company_app_id:info.company_app_id,//企业id           
              title:info.title,//招聘标题
              logo:info.logo,//招聘头像
              type_id:1,//招聘类型1兼职2全职
              type_remarks:info.type_remarks,//招聘描述
              class_id:info.class_id,//职位分类id
              class_name:info.class_name,
              address:info.address,//地址信息
              job_start_at:info.job_start_at,//活动开始时间-时间戳
              job_end_at:info.job_end_at,//活动结束时间-时间戳
              registration_end_at:info.registration_end_at,//报名截止时间
              sex:info.sex,//性别1男2女
              education:info.education,//学历 0 不限 1 初中及以下 2 高中 3 大专 4 本科 5 研究生
              major:info.major,//专业要求
              job_require:info.job_require,
              age_min:info.age_min,//最小年龄
              age_max:info.age_max,//最大年龄
              photo:info.photo,//工作环境
              description:info.description,//职位描述

              unit:info.unit,//工资单位1 天 2 小时 3 月 4 次 5 单
              wages_min:info.wages_min,//最低薪资
              wages_max:info.wages_max,//最高薪资
              wages_way:info.wages_way,//工资计算方式  

              method:info.method,//1:日结，2:月结，3:周结，:4完工结
              benefits:info.benefits,//工作福利标签

              work_start_time:info.work_start_time,//每日工作开始时间
              work_end_time:info.work_end_time,//每日工作结束时间
              contact:info.contact,//联系人
              phone:info.phone,//联系电话

          }
          //that.formData=obj;
          Object.assign( that.formData,obj)

          /*
          var wages=[];
          for (let item of that.formData.wages_way) {
            var itemarr=item.split("-");

            wages.push({
              wages_way1:itemarr[0],
              wages_way2:itemarr[1],
            });
          }
          this.formData.wages_way=wages;*/

          that.formData.job_start_at=that.formateDate2(that.formData.job_start_at);
          that.formData.job_end_at=that.formateDate2(that.formData.job_end_at);
          that.formData.registration_end_at=that.formateDate2(that.formData.registration_end_at);

          this.$refs.one.setParams(that.formData);
          this.$refs.two.setParams(that.formData);

        }else{
          that.$message.error("获取信息失败");
        }
      });
    },


   formateDate2 (time) {
    console.log(time);
      if(!time){
        return "";
      }
     let date = new Date(time*1000)
     return date;
    // return formateDate(date, 'YYYY-MM-dd hh:mm:ss')
    },

    submitDemand(){
      var that = this;
     

      var params=this.formData;

      /*
       var wages=[];
      for (let item of that.formData.wages_way) {
        wages.push(item.wages_way1+"-"+item.wages_way2)
      }
      params.wages_way=wages;*/

      addJob(params).then((response) => {
        console.log('submitDemand',response);
        if(response.code==200){
          that.stepActive++
        }else{
          that.$message.error(response.msg?response.msg:"提交失败");
        }
      });
      
    },

    updateJob(){
      var that = this;
      /*var wages=[];

      for (let item of that.formData.wages_way) {
        wages.push(item.wages_way1+"-"+item.wages_way2)
      }
      this.formData.wages_way=wages;*/

      updateJob(this.formData).then((response) => {
        console.log('submitDemand',response);
        if(response.code==200){
          that.stepActive++
        }else{
          that.$message.error(response.msg?response.msg:"操作失败");

        }
      });
      
    },

    



  }
};
</script>

<style lang="scss" scoped>
.pub_top {
  width: 1200px;
  line-height: 20px;
  margin: 0 auto 20px;
  font-size: 14px;
}
.pub_main {
  width: 1200px;
  border-radius: 6px;
  margin: 0 auto;
  box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.15);
  > h3 {
    font-size: 18px;
    line-height: 60px;
    padding-left: 25px;
    font-weight: bold;
    border-bottom: 1px #ccc solid;
  }
  .step_box {
    padding: 30px;
    .step_top {
      width: 700px;
      margin: 5px auto 30px;
    }
  }
}
</style>